import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

const rootSearchSchema = z.object({
  redirect: z.string().optional(),
})

export const Route = createFileRoute('/')({
  validateSearch: (search) => rootSearchSchema.parse(search),
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isAuthenticated) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
})
